var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8512",
    "data-name": "Group 8512",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.906,
    height: 11.906,
    viewBox: "0 0 11.906 11.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M331.514,237.166a.514.514,0,0,1-.514-.514V233.91a.514.514,0,0,1,1.028,0v2.741a.514.514,0,0,1-.514.514Z",
    transform: "translate(-325.561 -228.703)",
    fill: "#c4c3c3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M135.953,61.028a4.925,4.925,0,1,1-4.925,4.925,4.93,4.93,0,0,1,4.925-4.925m0-1.028a5.953,5.953,0,1,0,5.953,5.953A5.953,5.953,0,0,0,135.953,60Z",
    transform: "translate(-130 -60)",
    fill: "#c4c3c3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M327.952,164.611a.63.63,0,1,1-.63-.63.63.63,0,0,1,.63.63",
    transform: "translate(-321.369 -161.168)",
    fill: "#c4c3c3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.4da8600b4bbbf8aa5982061b51dc3bfb.svg";
export { ForwardRef as ReactComponent };